var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKeepInKeepOut(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.74981 5.13823H16.2225C15.2264 2.53825 12.9327 0.627407 10.1867 0.128906L7.45898 5.44565C7.85957 5.24275 8.30083 5.13823 8.74981 5.13823Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M8.75053 10.8608H1.27734C2.29551 13.5187 4.6663 15.4514 7.48448 15.8997L10.177 10.4805C9.74234 10.7313 9.252 10.8608 8.75053 10.8608Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M6.00827 8.82116L3.14874 2.28906L3.09307 2.34382C1.64592 3.79116 0.75 5.79129 0.75 8.00024C0.75 8.83002 0.876787 9.63048 1.11105 10.3835L1.13672 10.3819H7.16367C6.61017 10.0127 6.19936 9.46007 6.00827 8.82116Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M3.52051 1.94561L5.93788 7.4682C6.0299 6.97902 6.24621 6.53368 6.55273 6.16651L9.6881 0.0545307C9.38045 0.0186313 9.06757 0 8.75015 0C6.75086 0 4.92267 0.73321 3.52051 1.94561Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M13.9917 14.044L11.5673 8.50391C11.5123 8.81269 11.4078 9.10443 11.2619 9.37094L7.98633 15.9639C8.23763 15.988 8.49234 16.0003 8.75001 16.0003C10.7547 16.0003 12.5877 15.2625 13.9917 14.044Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M11.4317 7.00068L14.3628 13.6989C15.895 12.1863 16.7495 10.153 16.7495 7.99881C16.7495 7.16927 16.623 6.36926 16.3887 5.61719H10.335C10.4922 5.72193 10.6388 5.8419 10.7721 5.97527C11.0602 6.2636 11.2868 6.61237 11.4317 7.00068Z",
    fill: "#F0F0F0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeepInKeepOut);
export default __webpack_public_path__ + "static/media/Keep-In-Keep-Out.3bacce23d14386e9e4f95fc3535ff5d2.svg";
export { ForwardRef as ReactComponent };